import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive text-destructive-foreground",
        outline: "text-foreground",
        success: "border-transparent bg-success/15 text-success border-success/20",
        warning: "border-transparent bg-warning/15 text-warning border-warning/20",
        info: "border-transparent bg-info/15 text-info border-info/20",
        accent: "border-transparent bg-accent/15 text-accent border-accent/20",
        gold: "border-transparent bg-gold/15 text-gold border-gold/20",
        // Loan status badges
        lead: "bg-info/15 text-info border border-info/20",
        login: "bg-warning/15 text-warning border border-warning/20",
        sanction: "bg-accent/15 text-accent border border-accent/20",
        disbursed: "bg-success/15 text-success border border-success/20",
        query: "bg-destructive/15 text-destructive border border-destructive/20",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
